import { DeleteBaseBusinessForecastForReceiptRequest } from '@/coreInfrastructureModule/axios/generated/forecastForReceiptManage/api';

/**
 * 関連取引と受領用内示の連携を削除するアダプタ
 */
export class DeleteBaseBusinessForecastForReceiptAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param baseBusinessIds - 関連取引IDの配列
   * @param forecastForReceiptId - 受領用内示ID
   */
  public static adaptForRequest(baseBusinessIds: string[], forecastForReceiptId: string): DeleteBaseBusinessForecastForReceiptRequest {
    return {
      deleteBaseBusinessForecastForReceiptInfo: {
        forecastForReceiptId: forecastForReceiptId,
        baseBusinessIds: baseBusinessIds,
      },
    };
  }
}
